const proposalQuestionAnswerModes = Object.freeze({
  SeleccionSimple: 1,
  SeleccionMultiple: 2,
  SeleccionSimpleconInformacióndeEvidencia: 3,
  SeleccionSingularVertical: 4,
  SeleccionSingularHorizontal: 5,
  TextoAbierto: 6,
  TextoNumerico: 7,
  SinTexto: 8,
  SeleccionMultipleconHijos: 9,
  Documento: 10,
  Estado: 11,
  Municipio: 12,
});

export default proposalQuestionAnswerModes;
